/*
	Generated on 12/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React from 'react';
import { Link, useNavigate } from "react-router";
import { useParams } from "@/commons/hooks/useParams"

import { useAuth } from '@/commons/auth';
import { Button, Modal,Spinner } from '@/commons/components';


import deleteKelas from '../services/deleteKelas'


import deleteJadwalKelas from '../services/deleteJadwalKelas'


import deleteKelasDosen from '../services/deleteKelasDosen'

import * as Layouts from "@/commons/layouts";

const DosenTable = ({ dosenKelasList,
		 
		 

	}) => {
  const { checkPermission } = useAuth();
  
  
  const [selectedKonfirmasiHapusDosenKelas, setSelectedKonfirmasiHapusDosenKelas] = React.useState(null);
  
  
  	const { 	id } = useParams();
  
  const [showModalKonfirmasiHapusKelas, setShowModalKonfirmasiHapusKelas] = React.useState(false);
  
  
  
  	
    const hapus = async (selectedKonfirmasiHapusKelas) => {
      await deleteKelas({
        kelasId: selectedKonfirmasiHapusKelas.kelasId,
      });
  		window.location.reload()
    }
  const [showModalKonfirmasiHapusJadwalKelas, setShowModalKonfirmasiHapusJadwalKelas] = React.useState(false);
  
  
  
  	
    const hapusJadwal = async (selectedKonfirmasiHapusJadwalKelas) => {
      await deleteJadwalKelas({
        id: selectedKonfirmasiHapusJadwalKelas.id,
      });
  		window.location.reload()
    }
  const [showModalKonfirmasiHapusDosenKelas, setShowModalKonfirmasiHapusDosenKelas] = React.useState(false);
  
  
  
  	
    const hapusDosen = async (selectedKonfirmasiHapusDosenKelas) => {
      await deleteKelasDosen({
        id: selectedKonfirmasiHapusDosenKelas.id,
      });
  		window.location.reload()
    }
  
  return (
    <Layouts.ListComponentTableLayout
  	  items={[dosenKelasList]}
  	  itemsAttrs={[
          {
            id: "nama",
            condition: "",
            label: "Nama",
  		  featureName: "dosenName",
            editable: false
          }
  ,
          {
            id: "nIP",
            condition: "",
            label: "NIP",
  		  featureName: "dosenNip",
            editable: false
          }
  ,
          {
            id: "bobot",
            condition: "",
            label: "Bobot",
  		  featureName: "bobot",
            editable: false
          }
  ]}
        itemsEvents={(dosenItem) => [
          checkPermission("UpdateKelasDosen") &&  (
            
            <Link to={`/kelas/${id}/ubah-dosen?id=${dosenItem.id}`}>
              <Button
            	id="_emLY4C5dEfCJ1YDat3KRPQ"
                size="sm"
                variant=
                    "primary"
              >
                Ubah Dosen
              </Button>
            </Link>
            
          )
          
  ,
          checkPermission("DeleteKelasDosen") &&  (
    
    <Link to=''>
      <Button
    	id="_mdu24C5QEfCiIOe1nt4Q7w"
        size="sm"
        variant=
                    "info"
        onClick={() => {
          setSelectedKonfirmasiHapusDosenKelas(dosenItem);
          setShowModalKonfirmasiHapusDosenKelas(true);
        }}
      >
        Hapus Dosen
      </Button>
    </Link>
    
  )
  
        ]}
  	itemsModals={(dosenItem) => [
      <>
  		<Modal
  		isShow={showModalKonfirmasiHapusKelas}
  		title={"Konfirmasi Hapus Kelas"}
  		text={"Are you sure want to proceed?"}
  		>
  		
  		
  		
  		
  		
  				<Link to=''><Button className={`w-full`} variant="tertiary" onClick={() => setShowModalKonfirmasiHapusKelas(false)}>Batal</Button></Link>
  		
  		<Button
  		  id="_37Hf4Jw5Ee-ejYgMQj2CMA"
  		  variant="danger"
  		  onClick={() => hapus(selectedKonfirmasiHapusKelas)}
  		>
  		  Hapus
  		</Button>
  		</Modal>
  		
  		<Modal
  		isShow={showModalKonfirmasiHapusJadwalKelas}
  		title={"Konfirmasi Hapus Jadwal Kelas"}
  		text={"Are you sure want to proceed?"}
  		>
  		
  		
  		
  		
  		
  				<Link to=''><Button className={`w-full`} variant="tertiary" onClick={() => setShowModalKonfirmasiHapusJadwalKelas(false)}>Batal</Button></Link>
  		
  		<Button
  		  id="_v6jJQCwkEfCoct7gkgY0lg"
  		  variant="danger"
  		  onClick={() => hapusJadwal(selectedKonfirmasiHapusJadwalKelas)}
  		>
  		  Hapus
  		</Button>
  		</Modal>
  		
  		<Modal
  		isShow={showModalKonfirmasiHapusDosenKelas}
  		title={"Konfirmasi Hapus Dosen Kelas"}
  		text={"Are you sure want to proceed?"}
  		>
  		
  		
  		
  		
  		
  				<Link to=''><Button className={`w-full`} variant="tertiary" onClick={() => setShowModalKonfirmasiHapusDosenKelas(false)}>Batal</Button></Link>
  		
  		<Button
  		  id="_JkeXIC5REfCiIOe1nt4Q7w"
  		  variant="primary"
  		  onClick={() => hapusDosen(selectedKonfirmasiHapusDosenKelas)}
  		>
  		  Hapus
  		</Button>
  		</Modal>
      </>
      ]}		
  />
  )
};

export default DosenTable;
